import { Link, useLocation } from "react-router-dom";
import { SIGNALS } from "@/constants/testIds";

const TABS = [
  { to: "/signals/queue", label: "Review queue", testid: SIGNALS.tabQueue },
  { to: "/signals/registry", label: "Registry", testid: SIGNALS.tabRegistry },
];

export function SignalsTabs() {
  const { pathname } = useLocation();
  return (
    <div className="mt-6 inline-flex gap-1 rounded-full border border-border/60 bg-card/40 p-1">
      {TABS.map((t) => {
        const active = pathname.startsWith(t.to);
        return (
          <Link
            key={t.to}
            to={t.to}
            data-testid={t.testid}
            className={`rounded-full px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.14em] transition-colors ${
              active ? "bg-accent/15 text-accent" : "text-muted-foreground hover:text-foreground"
            }`}
          >
            {t.label}
          </Link>
        );
      })}
    </div>
  );
}
